// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-user-safety-confirm-answer[data-v-44c07a3f]{width:100%;margin-left:auto;margin-right:auto}#other-user-safety-confirm-answer .cancel-btn[data-v-44c07a3f]{width:130px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
